import { jsonp, objectToQueryParams } from '@fox/atoms/utils/jsonp';
import React, { useState } from 'react';
import { FatZebraResponse, PaymentAddComponentProps, PaymentOptionalCvv } from '../../../contracts';
import { CardForm } from '../../card-helpers';

export const FatZebraAddCreditCard = ({
	onSuccess,
	completeIntent,
	intentData,
	settings,
	onCancel,
	showSave,
	optionalCvv
}: PaymentAddComponentProps & PaymentOptionalCvv) => {
	const [errors, setErrors] = useState<string[]>([]);
	const returnPath = intentData.data?.['returnPath'];
	const baseUrl = intentData.data?.['baseUrl'];

	const submitFunc = submitData => {
		return new Promise((resolve, reject) => {
			jsonp(
				`${baseUrl}credit_cards/direct/${settings?.['user']}.json?${objectToQueryParams({
					card_holder: submitData.cardHolder,
					card_number: submitData.cardNumber,
					expiry_month: submitData.expires.month,
					expiry_year: submitData.expires.year,
					return_path: returnPath,
					verification: intentData.key,
					is_billing: 'true'
				})}`,
				{},
				(_, res: FatZebraResponse) => {
					if (res.r === 1) {
						completeIntent(
							intentData.intentId,
							JSON.stringify({
								cardHolder: res.card_holder,
								maskedCardNumber: res.card_number,
								expiryDate: submitData.expires,
								isBilling: true,
								token: res.token
							})
						)
							.then(result => {
								onSuccess(result);
								resolve(result);
							})
							.catch(error => {
								setErrors(['Unable to save credit card details']);
								reject(error);
							});
					} else {
						setErrors(['Card tokenisation failed']);
						reject('Card tokenisation failed');
					}
				}
			);
		});
	};
	return <CardForm onCancel={onCancel} submitFunc={submitFunc} apiErrors={errors} showSave={showSave} />;
};
